import { render, staticRenderFns } from "./trainList.vue?vue&type=template&id=4d13a894&scoped=true&"
import script from "./trainList.vue?vue&type=script&lang=js&"
export * from "./trainList.vue?vue&type=script&lang=js&"
import style0 from "./trainList.vue?vue&type=style&index=0&id=4d13a894&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d13a894",
  null
  
)

component.options.__file = "trainList.vue"
export default component.exports